export default {
     api: "/prod-api"
}
